<template>
  <nav class="navbar navbar-expand d-lg-none justify-content-between align-items-center mobile-topbar">
    <h5 class="mb-0 fw-bold text-theme">
      <i class="fa-solid fa-utensils me-2"/>
      {{ shopName + ' POS' }}
      <small class="fw-normal opacity-50 ms-1" style="font-size: 0.65rem;">· {{ $appName }}</small>
    </h5>
    <div class="d-flex align-items-center gap-1">
      <!-- เครื่องพิมพ์ของเครื่องนี้ — บนมือถือ/แท็บเล็ตไม่ต้องเปิดเมนูข้างก่อน -->
      <printer-settings-button v-if="canDirectPrint" btn-class="btn btn-outline-light btn-sm border-0" />
      <button class="btn btn-outline-light btn-sm border-0" type="button" @click="$emit('toggle-sidebar')">
        <i class="fa-solid fa-bars fa-lg"/>
      </button>
    </div>
  </nav>
</template>

<script>
import { useShopStore } from '@/stores/shop.store';
import PrinterSettingsButton from '@/components/printer-settings/PrinterSettingsButton.vue';
import { canDirectPrint } from '@/utils/printerSettings';

export default {
  name: "POSTopMenu",
  components: { PrinterSettingsButton },
  emits: ['toggle-sidebar'],
  data() {
    // iPhone/iPad พิมพ์ตรงไม่ได้ — ไม่มีอะไรให้ตั้ง ไม่ต้องโชว์ไอคอน
    return { canDirectPrint: canDirectPrint() };
  },
  computed: {
    shopName() { return useShopStore().name; }
  },
  methods: {
  }
}
</script>
